import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { PropTypes } from 'prop-types';
import styles from '../Product/ProductDetails-tw-styles';
import bvstyles from '../../Generic/BuyNowLite/BuyNowLite-tw-styles';
import { getCdnImage } from '../../../utils/ImageManager';
import getCdnSrcset from '../../../utils/srcSetHelper';
import { Button } from '../../Generic/Button';
import Typography from '../../Generic/Typography';
import Rating from '../../Generic/Rating';
import cardStyles from '../Product/card-tw-styles';
import SocialShare from '../SocialShare/SocialScrollWrapper';
import { getPrimaryRating } from '../../../services/bazaarvoice-api';
import BuyNowLiteDialog from '../../Generic/BuyNowLite/BuyNowLiteDialog';
import i18nMessages from '../../../constants/messages/pt-BR';
import DOMPurify from 'isomorphic-dompurify';
import Head from 'next/head';
import Image from 'next/image';
import { useBinLite } from '@procter-gamble/bin-lite-button'

const HeadingBanner = (props) => {
  const [open, setOpen] = useState(false);
  const [buyNowData, setBuyNowData] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [ratingData, setRatingData] = useState(null);
  const [detachBNL, setDetachBNL] = useState(false);
  const [isStickyVisible, setIsStickyVisible] = useState(false);
  const { pageData, product, constants, variant } = props;
const binParams = {
  gtin: pageData && pageData.gtin,
  passkey: process.env.BUYNOW_LITE_PASSKEY,
  orderby: 'random',
  retailersChoice: 'desired',
  isDevelopment: process.env.PROJECT_ENV.trim() === 'development'
}
const { retailers, fetchRetailers } = useBinLite(binParams)
  useEffect (async() => {
    const isMobile = window.innerWidth < 767;
    setIsMobile(isMobile);
    handleWindowChange();
    window.addEventListener(i18nMessages.resize, handleWindowChange);
    
    // Track sticky header visibility based on scroll with hysteresis to prevent flicker at 200% zoom
    const SHOW_AT = -4; // show only once clearly past
    const HIDE_AT = 8;  // hide only once clearly back
    
    const handleScroll = () => {
      const topImageWrapper = document.getElementById(i18nMessages.topImageWrapper);
      if (topImageWrapper) {
        const rect = topImageWrapper.getBoundingClientRect();
        // Use hysteresis to prevent oscillation when focus changes at high zoom
        setIsStickyVisible(prev => {
          if (!prev) return rect.bottom <= SHOW_AT;
          return rect.bottom <= HIDE_AT;
        });
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial state
    
    const { locale } = props;
    const productIdList = [];
    let productDetail = pageData;
    if (productDetail && productDetail.ratingAndReviewId) {
      productIdList.push(productDetail && productDetail.ratingAndReviewId);
      getPrimaryRating(productIdList, locale)
        .then(res => {
          if (res.data.Results.length > 0) {
            setRatingData(res.data.Results[0]);
          }
        })
        .catch(err => {
          throw new Error(err);
        });
    }
    
    return () => {
      window.removeEventListener(i18nMessages.resize, handleWindowChange);
      window.removeEventListener('scroll', handleScroll);
    };
  },[])

  const handleDialogViewState = async() => {
    setOpen(!open);
    setBuyNowData(null)
    if (detachBNL) {
      onclick({ data: retailers });
    }
  };

  const handleWindowChange = () => {
    const isDesktop = window.innerWidth > 1023;
    setIsDesktop(isDesktop)
    // this.setState({
    //   isDesktop: isDesktop,
    // });
  };
  const averageOverallRatingFormat = avgOverAllRating => {
    if (avgOverAllRating % 1 === 0) {
      return avgOverAllRating;
    } else {
      return avgOverAllRating.toFixed(2);
    }
  };
  // render() {
    // const { ratingData, open, buyNowData, isDesktop, detachBNL, isMobile } = this.state;
    return (
      <>
        <Head>
          <link rel="preconnect" href="https://api.bazaarvoice.com/"></link>
          {pageData.productImage.url && (
            <link
              rel="preload"
              href={getCdnImage(pageData.productImage.url, { w: 750 })}
              as="image"
            />
          )}
        </Head>
        <div className={styles.headingBannerMainParent}>
          <div
            id={i18nMessages.middleHeader}
            className={styles.headingBannerFixed}
            aria-hidden={!isStickyVisible}
            style={!isStickyVisible ? { display: 'none' } : undefined}
          >
            <div className={styles.productImageWrapperFixed}>
              <div className={styles.productImageFixed}>
                <picture>
                  <source
                    srcSet={getCdnSrcset(pageData.productImage.url, 1600, 768)}
                    media="(min-width: 768px)"
                  />

                  <img
                    className={styles.headingBannerMainImg}
                    src={getCdnImage(pageData.productImage.url, {
                      w: 750,
                    })}
                    alt={pageData?.productImage?.description}
                  />
                </picture>
              </div>
            </div>
            <div className={styles.headingTextWrapperFixed}>
              <div className={styles.productTitleFixed}>
                <Typography
                  component="h3"
                  className={classNames(styles.productTitleTextFixed)}
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(pageData.productName),
                  }}
                />
              </div>

              <div className={styles.productRatingWrapper}>
                <div className={styles.productRatingFixed}>
                  <Rating
                    rating={
                      ratingData && ratingData.ReviewStatistics
                        ? ratingData.ReviewStatistics.AverageOverallRating
                        : 0
                    }
                  />
                  <Typography
                    component="span"
                    className={cardStyles['ListingCard'].ratingTextCount}
                    tabIndex={0}
                    role="text"
                    aria-label={
                      (() => {
                        const count = ratingData && ratingData.ReviewStatistics
                          ? ratingData.TotalReviewCount
                          : 0;
                        return count === 1 ? '1 avaliação' : `${count} avaliações`;
                      })()
                    }
                  >
                    <span aria-hidden="true">
                      {`(${
                        ratingData && ratingData.ReviewStatistics
                          ? ratingData.TotalReviewCount
                          : 0
                      })`}
                    </span>
                  </Typography>
                </div>
                <div className={classNames(styles.socialShare)}>
                  <SocialShare
                    shareIcon={i18nMessages.shareProduct}
                    productName={pageData?.productName}
                    shareImage={
                      pageData.pageMetadata &&
                      pageData.pageMetadata.ogImage &&
                      pageData.pageMetadata.ogImage.url
                    }
                    shareDescription={
                      pageData.pageMetadata &&
                      pageData.pageMetadata.openGraphDescription
                    }
                    template={i18nMessages.productSticky}
                  />
                  <Typography
                    component="span"
                    className={classNames(styles.count_individualrating)}
                    title={i18nMessages.share}
                  >
                    {constants.toShare}
                  </Typography>
                </div>
              </div>
              {isDesktop && (
                <div
                  className={styles.headingBannerBtnParent}
                  id={i18nMessages.buyNowBtnWrapper}
                >
                  <div
                    id={i18nMessages.buyNowBtn}
                    className={styles.headingBannerMainBtn}
                  >
                    <Button
                      className={bvstyles.buyNowBtn.buyNow}
                      data-action-detail={pageData && pageData.gtin}
                      onClick={handleDialogViewState}
                    >
                      {constants.buyNow}
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={styles.headingBanner}>
            <div className={styles.mainproductImageWrapper}>
              <div
                id={i18nMessages.topImageWrapper}
                className={styles.productImageWrapper}
              >
                {pageData.packshotType && pageData.packshotType == 'mask' ? (
                  <div className={styles.maskImage}>
                    <picture>
                      <source
                        srcSet={getCdnSrcset(
                          pageData.productImage.url,
                          1600,
                          768
                        )}
                        media="(min-width: 768px)"
                      />
                      <img
                        id={i18nMessages.topImage}
                        className={styles.headingBannerProdImg}
                        src={getCdnImage(pageData.productImage.url, {
                          w: 750,
                        })}
                        alt={
                          pageData?.productImage?.description ||
                          pageData.productName
                        }
                      />
                    </picture>
                  </div>
                ) : (
                  <div className={styles.productImage}>
                    <picture>
                      <source
                        srcSet={getCdnSrcset(
                          pageData.productImage.url,
                          1600,
                          768
                        )}
                        media="(min-width: 768px)"
                      />
                      <Image
                        id={i18nMessages.topImage}
                        className={styles.headingBannerProdMobImg}
                        src={getCdnImage(pageData.productImage.url, {
                          w: 750,
                        })}
                        alt={
                          pageData?.productImage?.description ||
                          pageData.productName
                        }
                        priority={true}
                        loading="eager"
                        height={isMobile ? 970 : 720}
                        width={isMobile ? 364 : 270}
                      />
                    </picture>
                  </div>
                )}
              </div>
            </div>
            <div className={styles.headingTextWrapper} tabIndex="0">
              <div>
                <div
                  id={i18nMessages.topHeaderText}
                  className={styles.topHeadingTextWrapper}
                >
                  <div className={styles.productCategory}>
                    <Typography
                      component="h2"
                      className={classNames(styles.productCategoryText)}
                    >
                      {pageData.productCategoryType}
                    </Typography>
                  </div>
                  <div
                    id={i18nMessages.topHeaderTextMain}
                    className={styles.productTitle}
                  >
                    <Typography
                      component="h1"
                      className={classNames(styles.productTitleText)}
                      id={i18nMessages.topHeaderTextBig}
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(pageData.productName),
                      }}
                    />
                  </div>
                  <div className={styles.productRatingWrapper}>
                    <div className={styles.productRatingFixed}>
                      <Rating
                        rating={
                          ratingData && ratingData.ReviewStatistics
                            ? ratingData.ReviewStatistics.AverageOverallRating
                            : 0
                        }
                      />
                      <Typography
                        component="span"
                        className={cardStyles['ListingCard'].ratingTextCount}
                        tabIndex={0}
                        role="text"
                        aria-label={
                          (() => {
                            const count = ratingData && ratingData.ReviewStatistics
                              ? ratingData.TotalReviewCount
                              : 0;
                            return count === 1 ? '1 avaliação' : `${count} avaliações`;
                          })()
                        }
                      >
                        <span aria-hidden="true">
                          {`(${
                            ratingData && ratingData.ReviewStatistics
                              ? ratingData.TotalReviewCount
                              : 0
                          })`}
                        </span>
                      </Typography>
                    </div>
                    <div className={classNames(styles.socialShare)}>
                      <SocialShare
                        shareIcon={i18nMessages.shareProduct}
                        productName={pageData?.productName}
                        shareImage={
                          pageData.pageMetadata &&
                          pageData.pageMetadata.ogImage &&
                          pageData.pageMetadata.ogImage.url
                        }
                        shareDescription={
                          pageData.pageMetadata &&
                          pageData.pageMetadata.openGraphDescription
                        }
                        template={i18nMessages.product}
                      />
                      <Typography
                        component="span"
                        className={classNames(styles.count_individualrating)}
                        title={i18nMessages.share}
                      >
                        {constants.toShare}
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
              <div clasName={styles.aboutSection}>
                <Typography
                  component="h2"
                  className={classNames(styles.aboutSectionText)}
                >
                  {constants.overview}
                </Typography>
              </div>
              <div className={styles.productDescription}>
                <Typography
                  component="span"
                  className={classNames(styles.desc_review_count)}
                  title={`${product && product.productName} |  ${
                    constants.pdpTitle
                  }`}
                  // onClick={ratingLink}
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(pageData.shortDescription),
                  }}
                />
              </div>
              {isDesktop && (
                <div id={i18nMessages.buyNowBtnWrapper}>
                  <div
                    id={i18nMessages.buyNowBtn}
                    className={styles.headingBannerBuyNowBtn}
                  >
                    {/* <BuyNowLiteComponent
                      gtinId={pageData && pageData.gtin}
                      variant={
                        pageData &&
                        pageData.variantsCollection &&
                        pageData.variantsCollection.items
                      }
                      linkText={constants.buyNow}
                      productShortName={pageData && pageData.productShortName}
                    /> */}
                    <Button
                      className={bvstyles.buyNowBtn.buyNow}
                      data-action-detail={pageData && pageData.gtin}
                      onClick={handleDialogViewState}
                      aria-label={`Comprar ${pageData?.productShortName || pageData?.productName || ''}`}
                    >
                      {constants.buyNow}
                    </Button>
                  {!detachBNL ? (
                    <BuyNowLiteDialog
                      open={open}
                      variant={variant}
                      productShortName={pageData && pageData.productShortName}
                      productData={pageData}
                      onCloseHandler={handleDialogViewState}
                      buyNowData={buyNowData}
                    />
                  ) : null}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
// }
export default HeadingBanner;

HeadingBanner.propTypes = {
  pageData: PropTypes.oneOfType([PropTypes.object]).isRequired,
  product: PropTypes.oneOfType([PropTypes.object]).isRequired,
  locale: PropTypes.string.isRequired,
  constants: PropTypes.oneOfType([PropTypes.object]).isRequired,
  variant: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const HeadingBanner = ({prop = val, variant = [] }) =>
